import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from 'app/shared/services/shared.service';
import { UserService } from 'app/shared/services/user.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@Component({
  selector: 'error-component',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent {
  public isLoading: boolean;

  constructor(
    public router: Router,
    public sharedService: SharedService,
    public userService: UserService,
    public ga: GoogleAnalyticsService
  ) {
    this.isLoading = true;
  }

  ngOnInit() {
    if (this.sharedService.isDynamicRoutesLoaded) {
      if (this.userService.isPublisher() || this.userService.isCedatoPublisher()) {
        this.router.navigate([this.userService.getDefaultRoute()]);
      } else {
        this.sharedService.setPageTitle('PAGE_NOT_FOUND');
        this.isLoading = false;
      }
    }
  }
}
